import { State } from 'src/types'
import { beltBackStyleDrawer } from './beltBackStyleDrawer'
import { higashiUrawaBackStyleDrawer } from './higashiUrawaBackStyleDrawer'

export const backStyleOfGloveBackDrawer = (ctx: CanvasRenderingContext2D, state: State): void => {
  const needCatchFaceWrap = !state.baseModel?.isUBack || false

  switch (state?.baseModel?.productNumber) {
    case 'BKN-20':
      higashiUrawaBackStyleDrawer(ctx, state, needCatchFaceWrap)
      break
    default:
      beltBackStyleDrawer(ctx, state, needCatchFaceWrap)
      break
  }
}
